import { render } from "./materialShedInfo.vue?vue&type=template&id=40a2b3c2&scoped=true"
import script from "./materialShedInfo.vue?vue&type=script&lang=js"
export * from "./materialShedInfo.vue?vue&type=script&lang=js"

import "./materialShedInfo.vue?vue&type=style&index=0&id=40a2b3c2&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a2b3c2"]])

export default __exports__